import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-history-modal',
    templateUrl: './history-modal.component.html',
    styleUrls: ['./history-modal.component.scss'],
    standalone: false
})
export class HistoryModalComponent implements OnInit {
  @Input() message: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
